import { HOLIDAYS } from '../action-types/holidays-types';

const initialState = {
  loading: false,
  holidays: [],
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case HOLIDAYS.REQUEST:
      return {
        ...state,
        loading: true,
        holidays: [],
      };
    case HOLIDAYS.SUCCESS:
      return {
        ...state,
        holidays: action.payload.data,
        loading: false,
      };
    case HOLIDAYS.REJECTED:
      return {
        ...state,
        error: [action.payload],
        holidays: [],
        loading: false,
      };
    default:
      return state;
  }
}
